<template>
  <div id="inOut">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "in-and-out",
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inAndOut/inOut.vue